<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-card-section>
        <div class="text-h5">Confirm your action</div>
        <q-separator/>
      </q-card-section>

      <q-card-section class="q-my-md">
        <div>Do you really want to delete memo link "<u><i>{{ props.link }}</i></u>"?</div>
      </q-card-section>

      <q-card-actions align="between" class="q-px-md">
        <q-btn color="negative" label="OK" @click="onOKClick" push/>
        <q-btn color="primary" label="Cancel" @click="onDialogCancel" push/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import {useDialogPluginComponent} from 'quasar'

const props = defineProps(['link']);

defineEmits([...useDialogPluginComponent.emits]);

const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

function onOKClick() {
  onDialogOK();
}
</script>
